module.exports = __webpack_public_path__ + "img/featuresIcons.f1aaf913.svg";